import React, { useEffect, useState } from "react";
import herobanner from "../../../assets/heroBanner.webp";
import SC from "./style";

const fadeInLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, delay: 1 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

function HeroSection() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Email submitted:", email);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Prakalpa",
      description:
        "An AI-powered project management solution designed to boost productivity and keep projects on track.",
      image: "https://prakalpa.ai/path-to-image.png",
      url: "https://prakalpa.ai/",
      applicationCategory: "ProjectManagementSoftware",
      operatingSystem: "All",
    });
    document.head.appendChild(script);
  }, []);

  return (
    <SC.MainContainer>
      <SC.Container>
        <SC.LeftSection
          whileInView="visible"
          initial="hidden"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInLeft}
        >
          <SC.Tag>Plan. Track. Collaborate. Succeed.</SC.Tag>
          <SC.Title>
            <span>Prakalpa</span> – AI powered Project Intelligence Platform
          </SC.Title>
          {/* <TitleChild>
            AI-powered project management for seamless workflow
          </TitleChild> */}
          <SC.Description>
            Prakalpa transforms fragmented work data into real-time, AI-driven
            execution intelligence — helping organizations deliver faster,
            predict better, and scale smarter.
          </SC.Description>
        </SC.LeftSection>
        <SC.RightSection
          whileInView="visible"
          initial="hidden"
          viewport={{ once: true, amount: 0.5 }}
          variants={fadeInRight}
        >
          <SC.Image
            src={herobanner}
            alt="Project management software dashboard preview"
          />
        </SC.RightSection>
      </SC.Container>
      {/* <SC.EmailForm
        onSubmit={handleSubmit}
        whileInView="visible"
        initial="hidden"
        viewport={{ once: true, amount: 0.5 }}
        variants={fadeInUp}
      >
        <SC.Input
          type="email"
          placeholder="Enter your work email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <SC.Button
          type="submit"
          aria-label="Sign up with your email"
          loading="lazy"
        >
          Get Started for Free
        </SC.Button>
      </SC.EmailForm> */}
    </SC.MainContainer>
  );
}

export default HeroSection;
